(function(){
    'use strict';

/**
* @memberof app
* @ngdoc controller
* @name PublicacionesController
* @description
* This is main controller
**/ 

    angular
    .module('app')
    .controller('PublicacionesController', PublicacionesController);

    PublicacionesController.$inject = ["PublicacionesService","$timeout","$location",'$anchorScroll','$uibModal','$window','AnaliticaService'];

    function PublicacionesController(PublicacionesService,$timeout,$location,$anchorScroll,$uibModal,$window,AnaliticaService)
    {
    	var vm = this;
        vm.pag = 0;
        vm.maxPages = 0;
        vm.buscador = "";
        vm.articulos = [];
        vm.loading = false;
        vm.initVar = true;
        vm.buscarFiltros = function(){
            var url_string = window.location.href
            var url = new URL(url_string);

            if($location.search().pag){
                vm.pag = parseInt($location.search().pag);
            }
            
            if($location.search().buscador){
                vm.buscador = $location.search().buscador;
            }
            return true;

        }

        vm.getPublicaciones = function(){
            vm.loading = true;
            if(vm.initVar){
                 var resF = vm.buscarFiltros();
                 vm.initVar = false;
              }
            PublicacionesService.getPublicaciones(vm,function(data){
                vm.loading = false;
                vm.articulos = data.articulos;
                vm.maxPages = data.maxPages;
                if(vm.pag>0){
                    $("html, body").animate({ scrollTop: $('.filters-news').offset().top }, 1000);
                }
                var queryParams = new URLSearchParams(window.location.search);
                //console.log(vm);
               
                if(vm.pag){
                    queryParams.set("pag", vm.pag);
                }else{
                    queryParams.delete("pag");
                }
                if(vm.buscador){
                    queryParams.set("buscador", vm.buscador);
                }else{
                    queryParams.delete("buscador");
                }
                $location.url( "?"+queryParams.toString());
                //console.log(vm.maxPages );
            },function(){vm.loading = false;});
        };

        vm.next = function(){
        	vm.pag++;
        	vm.getPublicaciones();
        };

        vm.prev = function(){
        	vm.pag--;
        	vm.getPublicaciones();
        };
        
        vm.downloadModal = "";
        vm.abrirSolPDF = function(articulo_id,nombre){
	        vm.downloadModal = $uibModal.open({
	              animation: true,
	              ariaLabelledBy: 'modal-title-top',
	              ariaDescribedBy: 'modal-body-top',
	              templateUrl: 'solicitudpdf.html',
	              size: 'lg',
	              backdrop:'static',
	              controller: function($scope) {
	                    $scope.articulo_id = articulo_id;
	                    $timeout(function(){
	                    	$.material.checkbox();
	                    },100)
		                $scope.okForm = function(){
		                    vm.downloadModal.close();
		                }
		                $scope.koForm = function(){
		                    vm.downloadModal.close();
		                }
	               
	              }
	          });
            AnaliticaService.pageView('Form descarga: '+nombre,$window.location.pathname+'/form-download-opened',$window.location.pathname+'/form-download-opened');
        }
    }


})();